export default "__VITE_ASSET__15e46ca2__"